export default __webpack_public_path__ + "static/media/table-info-icon.5796211b.svg";